import { createServerFn } from "@tanstack/react-start";
import "@/lib/sentry";
import { z } from "zod";
import { captureServerException } from "@/lib/sentry";
import { updateSubscription } from "instantdb/server/userServer";

// Define the input schema using Zod
const purchaseSubscriptionIosInputSchema = z.object({
  userId: z.string(),
  result: z.string(),
  selectedPlan: z.enum(["monthly", "yearly"]), // Adjust enum values if different
});

// Define the server function
export const purchaseSubscriptionIos = createServerFn({
  method: "POST",
})
  .validator(purchaseSubscriptionIosInputSchema)
  .handler(async (ctx) => {
    const { userId, result, selectedPlan } = ctx.data;
    console.log("purchaseSubscriptionIos", ctx.data);

    if (!userId || !result || !selectedPlan) {
      throw new Error("Missing required fields");
    }

    try {
      // Update user's subscription status using InstantDB mutation
      await updateSubscription({
        userId,
        selectedPlan,
        nextBillingDate: new Date(
          selectedPlan === "yearly"
            ? Date.now() + 365 * 24 * 60 * 60 * 1000
            : Date.now() + 30 * 24 * 60 * 60 * 1000,
        ).toISOString(),
        subscriptionProvider: "ios",
        status: "active",
      });

      return { success: true };
    } catch (error: unknown) {
      // Use captureServerException similar to cancel-subscription.ts
      captureServerException(error, {
        tags: {
          endpoint: "purchase-subscription-ios-server-fn",
          userId: userId,
        },
      });

      // Throw an error instead of returning json
      throw new Error(
        !import.meta.env.PROD
          ? error instanceof Error
            ? error.message
            : String(error)
          : "Failed to update subscription status",
      );
    }
  });
